<template>
  <v-card class="pa-3">
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-3 mb-4">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <span class="text-center text-lg d-block font-weight-medium w-full">سابقه مصرف دارو</span>
          </v-col>
          <v-col cols="1" class="text-left mt-n2 ml-2">
            <v-icon color="darkColor" @click="closeDialog()">mdi-close</v-icon>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="6">
        <v-row>
          <span>تاریخچه دارویی</span>
          <v-divider class="mt-3 mr-3 ml-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" class="card-style" height="32vh">
              <v-chip v-for="item in (flagShowForm == 4
                ? patientDrugHistoriesTypeList_4
                : flagShowForm == 5
                  ? patientDrugHistoriesTypeList_5
                  : patientDrugHistoriesTypeList)" :key="item.id" label color="background" text-color="darkColor"
                class="mr-2 mt-2">
                {{ item.title }}
                <v-icon class="mr-3" color="darkColor" @click="addPatientDrugHistoryTrumaType(item.title)">
                  mdi-plus mdi-18px
                </v-icon>
              </v-chip>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row>
          <span>تاریخچه دارویی انتخابی</span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" class="card-style" height="32vh">
              <v-chip v-for="item in selectedPatientDrugHistoriesTypeList" :key="item.id" color="darkColor"
                text-color="white" class="mr-2 mt-2">
                {{ item.title }}
                <v-icon class="mr-3" color="white" @click="deletePatientDrugHistoryFunction(item)">
                  mdi-close mdi-18px
                </v-icon>
              </v-chip>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <span>سایر تاریخچه های دارویی</span>
      <v-divider class="mt-3 mr-3"></v-divider>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="6">
        <v-text-field outlined label="سایر" dense v-model="otherPatientDrugHistory"
          prepend-inner-icon="mdi-text mdi-18px" clearable clear-icon="mdi-close-circle-outline">
          <template v-slot:append-outer>
            <v-btn color="darkColor" x-small elevation="0" class="py-5 mt-n2"
              v-on:keyup.enter="addOtherPatientDrugHistory()" @click="addOtherPatientDrugHistory()">
              <v-icon color="white">mdi-plus mdi-18px</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-btn rounded color="darkColor" dark @click="nextDialog()">بعدی (سابقه حساسیت)</v-btn>
      <v-btn text color="darkColor" @click="closeDialog()">بستن</v-btn>
    </v-row>
  </v-card>
</template>
<script>
import FollowUpPatientStep7Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep7Helper';
import PatientDrugHistoryMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientDrugHistoryMixin.js';
import SharedHelper from '@/Helpers/Shared';
import SharedMixin from '@/Mixins/Shared';
export default {
  mixins: [FollowUpPatientStep7Helper, PatientDrugHistoryMixin, SharedHelper, SharedMixin],
  mounted() {
    this.mounteLoding();
  },
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
    missionType: {
      type: String,
      require: true,
      default: '',
    },
    flagShowForm: {
      type: Number,
      require: true,
      default: null,
    },

  },
  methods: {
    mounte: function () {
      this.getAllPatientDrugHistoryFunction(this.patientId);
    },
    closeDialog() {
      this.$emit('reloadApiFun');
    },
    nextDialog() {
      this.$emit('goToNextDialog');
    },
  },
};
</script>
<style scoped>
.card-style {
  border: 1px solid var(--dark-color) !important;
  border-radius: 10px !important;
}
</style>
